import '../../modules/mode-components';

import * as angular from 'angular';
import * as $ from 'jquery';
import { debounce } from 'lodash';

function pivotResizeDirective($window, $timeout) {
  return {
    restrict: 'A',

    link: (scope, elem, attrs) => {
      const $elem = $(elem);

      const resizeHandler = (message) => {
        $elem.find('.mode-table-grid').css('max-height', $elem.height() - 10);
      };

      $($window).on('resize.pivot', debounce(resizeHandler, 100));

      scope.$on('$destroy', () => {
        $($window).off('resize.pivot');
      });
    },
  };
}

pivotResizeDirective.$inject = ['$window', '$timeout'];

angular.module('mode.components').directive('pivotResize', pivotResizeDirective);
